import get from "lodash/get";
import { useActivityFormStore } from "PFApp/activities/activity_form/activity_form_store";
import { useSubtemplate } from "PFApp/activities/activity_form/hooks/use_subtemplate";
import { AssigneeSelector } from "PFApp/components/activity_form/form_selectors/assignee_selector";
import { FIELD_ASSIGNEE_ID_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useFormValidation } from "PFApp/hooks/activity_form/use_form_validation";
import { Id } from "PFTypes";
import { Controller, useFormContext } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { HintWrapper } from "./hint_wrapper";

export const AssigneeSelect = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form" });
  const {
    control,
    formState: { errors }
  } = useFormContext();
  const { draft: submittedAsDraft } = useActivityFormStore((state) => state.submitOptions);
  const template = useActivityFormStore((state) => state.template);
  const subtemplate = useSubtemplate();
  const { isFieldRequired } = useFormValidation({ subtemplate, template });

  const required = isFieldRequired({ name: FIELD_ASSIGNEE_ID_KEY });

  return (
    <HintWrapper
      hint={
        <Trans
          i18nKey="sections.basicInformation.addAssigneeDescription"
          t={t}
          components={[<strong key="0" />]}
        />
      }
    >
      <Controller
        name={FIELD_ASSIGNEE_ID_KEY}
        control={control}
        rules={{
          validate: (value: Id) => {
            if (!submittedAsDraft && required && (!value || value === -1)) {
              return t("errors.cantBeBlank");
            }
            return true;
          }
        }}
        render={({ field }) => (
          <AssigneeSelector
            value={field.value}
            onChange={field.onChange}
            label={t("sections.basicInformation.assignee")}
            required={required}
            error={get(errors, field.name)?.message as string}
          />
        )}
      />
    </HintWrapper>
  );
};
